import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './paymentLayout.styles';
import Logo from '../../assets/real-sign.svg';
import Navbar from '../../agent-panel/layout/navbar';

const PaymentLayoutC = ({
  classes,
  children,
}: {
  classes: Object,
  children: React.Element,
}) => (
  <React.Fragment>
    <Navbar title="Settings" />
    <div className={classes.root}>
      <div className={classes.actionPanel}>
        <div>
          <div className={classes.datzLogo}>
            <Logo />
          </div>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default withStyles(styles, { withTheme: true })(PaymentLayoutC);
